import type { GiayBaoNo, GiayBaoNoInput } from '@/types/schemas';
import { useAuth } from '@/contexts/auth-context';
import { QUERY_KEYS } from '@/constants';
import { useRouter } from '@/routing';
import api from '@/lib/api';

interface UseGiayBaoNoMutationParams {
  formMode: string;
  selectedObj: GiayBaoNo | null;
  shouldEditWithUpdatedData: boolean;
  editGiayBaoNoUuid?: string | null;
  addItem: (data: GiayBaoNoInput) => Promise<unknown>;
  updateItem: (uuid: string, data: GiayBaoNoInput) => Promise<unknown>;
  deleteItem: (uuid: string) => Promise<unknown>;
  handleCloseForm: () => void;
  clearSelection: () => void;
  refreshData: () => Promise<unknown>;
}

export const useGiayBaoNoMutation = ({
  formMode,
  selectedObj,
  shouldEditWithUpdatedData,
  editGiayBaoNoUuid,
  addItem,
  updateItem,
  deleteItem,
  handleCloseForm,
  clearSelection,
  refreshData
}: UseGiayBaoNoMutationParams) => {
  const router = useRouter();
  const { entity } = useAuth();

  const handleCloseEditWithUpdatedData = () => {
    router.back();
  };

  const handleSubmit = async (data: GiayBaoNoInput) => {
    if (shouldEditWithUpdatedData && editGiayBaoNoUuid) {
      await updateItem(editGiayBaoNoUuid, data);
    } else if (formMode === 'add') {
      await addItem(data);
    } else if (formMode === 'edit' && selectedObj?.uuid) {
      await updateItem(selectedObj.uuid, data);
    }

    if (shouldEditWithUpdatedData) {
      handleCloseEditWithUpdatedData();
      return;
    }

    handleCloseForm();
    clearSelection();
    await refreshData();
  };

  const handleBulkDelete = async (uuids: string[]) => {
    await api.post(`/entities/${entity?.slug}/erp/${QUERY_KEYS.GIAY_BAO_NO}/bulk-delete/`, {
      list: uuids
    });
    await refreshData();
  };

  return {
    handleSubmit,
    handleDelete: deleteItem,
    handleBulkDelete,
    handleCloseEditWithUpdatedData
  };
};
